import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { cond, identity, stubTrue } from 'lodash'
import { Observable, throwError } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { appConfig } from '../../../../brands/_current/config/app-config'
import { createAppErrorClass } from '../../app-error/app-error'
import { Injectable } from '@angular/core'
import { and, isInstanceOf } from '@mycicero/functional-utilities'
import { environment } from '../../../../environments/environment'
import { EnvironmentName } from '../../../../environments/environment.enum'

export const UnsuccessfulResponse = createAppErrorClass<{ body: Record<string, unknown>; statusCode: number }>(
  'UnsuccessfulResponse',
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isApiCall = (httpResponse: HttpResponse<any>) =>
  environment.name === EnvironmentName.Dev
    ? httpResponse.url.includes(appConfig.myCiceroWebApi.urls._base)
    : httpResponse.url.startsWith(appConfig.myCiceroWebApi.urls._base)

@Injectable()
export class UnsuccessfulResponseInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      map(
        cond([
          [
            and(isInstanceOf(HttpResponse), isApiCall),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (httpResponse: HttpResponse<any>) => {
              if (httpResponse.body.Success !== false) {
                return httpResponse
              }
              throw new UnsuccessfulResponse('Server responded with Success = false', {
                body: httpResponse.body,
                statusCode: httpResponse.status,
              })
            },
          ],
          [stubTrue, identity],
        ]),
      ),
      catchError(
        cond([
          [isInstanceOf(UnsuccessfulResponse), (err) => throwError(() => err)],
          [stubTrue, (err) => throwError(() => err)],
        ]),
      ),
    )
  }
}
